import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const getTrendingClasses = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DASHBOARD.GET_TRENDING_CLASSES
  );
};

export default getTrendingClasses;
